import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	transition: all 2s ease-in-out;
	height: 100%;
`;

export const Sidebar = styled.div`
	display: flex;
	flex-direction: column;
	width: 320px;
	min-width: 320px;
	height: calc(100% - 2px);
	background: ${colors.white};
	box-shadow: 1px 2px 4px ${colors.grey3};
	padding-top: 20px;
	overflow: auto;
	z-index: 0;
`;

export const Content = styled.div`
	width: 100%;
	display: flex;
	overflow: auto;
	padding: 48px 32px;
	background-color: ${colors.grey1};
`;

export const Section = styled.div`
	padding: 12px 32px;
	width: 100%;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	line-height: 27px;
	margin-bottom: 16px;
`;

export const Description = styled.div`
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	color: ${colors.grey5};
	letter-spacing: 0.3px;
	margin-bottom: 15px;
`;

export const TabsWrapper = styled.div`
	padding: 32px 0;
`;

export const BottomSection = styled(Section)`
	border-top: 1px solid ${colors.grey3};
	margin-top: auto;
	padding-bottom: 22px;
`;
